import gql from './index';

interface RemoveResult {
  assets: {
    affected_rows: number;
    returning: Array<{
      id: string;
    }>;
  };
  table: {
    affected_rows: number;
    returning: Array<{
      id: string;
    }>;
  };
}

export default (
  tableName: string,
) => gql<RemoveResult>(`
  mutation delete_${tableName}(
    $id: uuid!
  ) {
    table: delete_${tableName}(
      where: {
        id: {
          _eq: $id
        }
      }
    ) {
      affected_rows
      returning {
        id
      }
    }

    assets: delete_asset(
      where: {
        _and: [
          {
            type: {
              _eq: "${tableName}"
            }
          },
          {
            type_id: {
              _eq: $id
            }
          }
        ]
      }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`);
